/**
 * Decides whether salary UI should offer an explanation (tooltip / tap-to-expand).
 * - Market median: enrichment filled pay when the employer did not state it.
 * - Unverified numeric range: processor output numbers without a salaryDetails quote from the ad.
 */

import { resolveJobSalaryListingProvenance } from './resolve-job-salary-listing-provenance';

export type SalaryInferenceExplanationKind =
  | 'market_median_from_similar_jobs'
  | 'numeric_range_without_listing_quote'
  | null;

function hasPositiveSalaryRange(
  salaryRangeMin: unknown,
  salaryRangeMax: unknown,
): boolean {
  return (
    typeof salaryRangeMin === 'number' &&
    typeof salaryRangeMax === 'number' &&
    Number.isFinite(salaryRangeMin) &&
    Number.isFinite(salaryRangeMax) &&
    salaryRangeMin > 0 &&
    salaryRangeMax > 0
  );
}

export function resolveSalaryInferenceExplanationKind(input: {
  salaryIsEstimate?: boolean | null;
  salaryRangeMin?: number | null;
  salaryRangeMax?: number | null;
  salaryDetails?: string | null;
}): SalaryInferenceExplanationKind {
  if (!hasPositiveSalaryRange(input.salaryRangeMin, input.salaryRangeMax)) {
    return null;
  }
  if (input.salaryIsEstimate === true) {
    return 'market_median_from_similar_jobs';
  }
  const listingProvenance = resolveJobSalaryListingProvenance({
    salaryRangeMin: input.salaryRangeMin,
    salaryRangeMax: input.salaryRangeMax,
    salaryDetails: input.salaryDetails,
  });
  if (listingProvenance === 'extracted_without_quote') {
    return 'numeric_range_without_listing_quote';
  }
  return null;
}
